import React from 'react';
import moment from 'moment';
import Tooltip from 'react-tooltip-lite';

import TextArea from './TextArea';
import DeleteMessage from '../DeleteMessage';
import getPublishTime from '../../services/getPublishTime';

import '../../css/Forum.css';

import I18n from '../../locales/i18n';

class Chat extends React.Component {
	constructor(props) {
		super(props);
		this.state = { messages: [], canGetMoreMessages: true, timeSinceStart: 0 };

		this.getMessages = this.getMessages.bind(this);
		this.onAddMessage = this.onAddMessage.bind(this);
		this.onDeleteMessage = this.onDeleteMessage.bind(this);

		this.chatContainer = React.createRef();
		this.chatListener = () => {};
		this.lastVisible = null;

		this.timesInterval = null;
	}
	componentWillUnmount() {
		this.chatListener();
		clearInterval(this.timesInterval);
	}
	componentDidMount() {
		if (this.props.event_id) {
			this.getMessages();
			this.timesInterval = setInterval(this.updateTimes, 120000);
		}
	}
	componentDidUpdate(nP, nS) {
		if (nP.event_id !== this.props.event_id) {
			this.getMessages();
		}
	}
	updateTimes = () => {
		this.setState({ timeSinceStart: moment().unix() });
	};

	getMessages() {
		const self = this;
		const _arr = self.state.messages;

		let query = (this.chatListener = this.props.firebase.db
			.collection('chats')
			.doc(this.props.event_id)
			.collection('messages')
			.orderBy('timestamp', 'desc'));

		if (_arr.length > 0) {
			if (this.lastVisible) {
				query = query.startAfter(this.lastVisible);
			}
		}

		this.chatListener = query.limit(15).onSnapshot((docs) => {
			if (docs.docs.length === 0) {
				self.setState({ canGetMoreMessages: false });
			}
			this.lastVisible = docs.docs[docs.docs.length - 1];
			let needChange = false;
			docs.docChanges().forEach(function (change) {
				if (change.type === 'added') {
					needChange = true;
					const message = change.doc.data();
					if (message.timestamp) {
						if (message.timestamp.seconds) {
							message.timestamp = message.timestamp.seconds;
						}
					} else {
						message.timestamp = moment(
							message.date,
							'YYYY-MM-DD HH:mm:ss Z'
						).unix();
					}

					_arr.push({
						id: change.doc.id,
						author: message.author,
						date: message.date,
						text: message.text,
						timestamp: message.timestamp,
					});
				}
			});

			if (needChange) {
				_arr.sort((a, b) => {
					if (
						typeof a.timestamp === 'undefined' ||
						typeof b.timestamp === 'undefined'
					) {
						return a.date > b.date ? 1 : 0;
					}
					if (a.timestamp > b.timestamp) {
						return 1;
					}
					if (a.timestamp < b.timestamp) {
						return -1;
					}
					return 0;
				});

				self.setState({ messages: _arr }, () => {
					self.chatContainer.current.scrollTop =
						self.chatContainer.current.scrollHeight -
						self.chatContainer.current.clientHeight;
				});
			}
		});
	}
	onAddMessage(text) {
		const message = {
			author: {
				id: this.props.author.id,
				name: this.props.author.name,
				photoURL: this.props.author.photoURL,
			},
			date: moment().format('YYYY-MM-DD HH:mm:ss Z'),
			timestamp: this.props.firebase.FIRESTORE_TIMESTAMP,
			text: text,
		};

		this.props.firebase
			.newRoom('chats', this.props.event_id, 'messages', message)
			.then(function () {})
			.catch((err) => {
				console.error(err);
			});
	}
	onDeleteMessage(id) {
		const self = this,
			_arrMessages = this.state.messages,
			_message = _arrMessages[id];

		_arrMessages.splice(id, 1);

		this.props.firebase
			.deleteRoom('chats', this.props.event_id, 'messages', _message.id)
			.then(function () {
				self.props.firebase
					.newRoom('chats', self.props.event_id, 'deleted_messages', _message)
					.then(function () {
						self.setState({ messages: _arrMessages });
					})
					.catch((err) => {
						console.error(err);
					});
			})
			.catch((err) => {
				console.error(err);
			});
	}
	render() {
		const { messages } = this.state,
			{ photoURL = '' } = this.props.author,
			isOwner = this.props.owner === this.props.author.id;

		return (
			<React.Fragment>
				<ol className="chat" ref={this.chatContainer}>
					{this.state.canGetMoreMessages && (
						<button
							onClick={this.getMessages}
							className="btn btn-primary btn-block mb-1"
						>
							{I18n('CHAT', 'SEE_MORE')}
						</button>
					)}
					{messages.map((message, idx) => {
						const _date =
							typeof message.timestamp === 'undefined'
								? message.date
								: moment.unix(message.timestamp).format('YYYY-MM-DD HH:mm:ss');

						return (
							<li className="other" key={message.id}>
								<div className="avatar">
									<img
										src={message.author.photoURL}
										alt="avatar"
										draggable="false"
									/>
									<DeleteMessage
										deleteLoading={false}
										isOwner={isOwner}
										onClick={this.onDeleteMessage}
										postIdx={idx}
									/>
								</div>
								<div className="msg">
									<p className="name">{message.author.name}</p>
									<p>{message.text}</p>

									<Tooltip content={message.date} direction="left">
										<span className="Forum__item_header_time">
											{getPublishTime(_date)}
										</span>
									</Tooltip>
								</div>
							</li>
						);
					})}
				</ol>
				{this.props.author.id !== undefined && this.props.author.id !== '' && (
					<TextArea
						onSend={this.onAddMessage}
						placeholder={I18n('CHAT', 'WRITE_A_MESSAGE')}
						photoURL={photoURL}
					/>
				)}
			</React.Fragment>
		);
	}
}

export default Chat;
